<template>
<div class="chapter">
<div class="inner_page">
<div class="titlePage" id="tp02">
<a id="page03">
<h2 class="halfTitlePageTitle" style="text-indent: 0%;"><span class="bold">THE DEAD TRAVEL FAST</span></h2>
</a></div>
<a id="page03">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312371111_ht02.vue?0ef737ee